import { render, staticRenderFns } from "./BillingPlansItem.component.vue?vue&type=template&id=5f4cad73&scoped=true"
import script from "./BillingPlansItem.component.vue?vue&type=script&lang=js"
export * from "./BillingPlansItem.component.vue?vue&type=script&lang=js"
import style0 from "./BillingPlansItem.component.vue?vue&type=style&index=0&id=5f4cad73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4cad73",
  null
  
)

export default component.exports